import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Инициализация Telegram WebApp
const tg = window.Telegram?.WebApp;
if (tg) {
    tg.expand();
    tg.enableClosingConfirmation();
}

// Отслеживаем реальную видимую область (visual viewport). При открытии
// экранной клавиатуры в Telegram mini-app layout-viewport не сжимается, из-за
// чего центрированные модалки уезжают под клавиатуру. Пишем размеры в CSS-
// переменные, которые использует контейнер прокрутки модалок (см. App.js).
const updateViewportVars = () => {
    const vv = window.visualViewport;
    const height = vv ? vv.height : window.innerHeight;
    const top = vv ? vv.offsetTop : 0;
    const root = document.documentElement;
    root.style.setProperty('--app-vvh', `${height}px`);
    root.style.setProperty('--app-vv-top', `${top}px`);
};
updateViewportVars();
if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateViewportVars);
    window.visualViewport.addEventListener('scroll', updateViewportVars);
}
window.addEventListener('resize', updateViewportVars);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);